module.exports = __webpack_public_path__ + "img/neotag-3-part-keyring-dark.43065e0e.png";